/**
 * Per-tab identifier for single-session enforcement.
 *
 * Stored in sessionStorage — NOT a per-page-load random — so a page REFRESH
 * keeps the same id (a refresh must not look like a second tab and trip the
 * server's concurrent-tab kill), while a genuinely new tab/window gets a fresh
 * sessionStorage and therefore a distinct id. A module cache keeps it stable
 * within a page load even if sessionStorage is unavailable (private mode).
 */
const KEY = 'transpay_tab_id';

let cached: string | null = null;

function generate(): string {
  try {
    return crypto.randomUUID();
  } catch {
    return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 14)}`;
  }
}

export function getTabId(): string {
  if (cached) return cached;
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = generate();
      sessionStorage.setItem(KEY, id);
    }
    cached = id;
  } catch {
    // sessionStorage blocked — stable for this page load only.
    cached = generate();
  }
  return cached;
}
